import React, { useState } from "react"
import tw from "twin.macro"
import styled, { keyframes } from "styled-components"

const fadeUpShow = keyframes`
  from {
    opacity:0;
    transform: translateY(5px);
  }

  to {
    opacity:1;
    transform: translateY(30px);
  }
`
const Tooltip = styled.div`
    animation: ${fadeUpShow} 0.5s forwards;
`
const TooltipArrow = styled.span`
    animation: ${fadeUpShow} 0.5s forwards;
`

const CompChartPrice = (props) => {
    const [tooltip, setTooltip] = useState(false)
    const fullPrice =
        props.name === "Simple Start"
            ? 10
            : props.name === "Essentials"
            ? 29
            : 49
    const dataSKU =
        props.name === "Simple Start"
            ? "ss"
            : props.name === "Essentials"
            ? "es"
            : "pl"
    let discountPrice = Math.trunc(fullPrice / 2)
    let remainder = fullPrice % 2 > 0
    function handleTooltipClick() {
        tooltip === false ? setTooltip(true) : setTooltip(false)
    }

    return (
        <div css={tw`mx-auto md:mt-5 md:mb-2 lg:my-0`}>
            <h3
                onClick={() => handleTooltipClick()}
                onMouseLeave={() => setTooltip(false)}
                css={tw`cursor-pointer lg:cursor-auto flex justify-center relative font-semibold text-center text-lg sm:text-xl mt-2 mb-3`}
                css={
                    props.crown &&
                    props.name === "Simple Start" &&
                    tw`text-green-200`
                }
                css={
                    props.crown &&
                    props.name === "Essentials" &&
                    tw`text-teal-300`
                }
                css={props.crown && props.name === "Plus" && tw`text-green-500`}
            >
                {props.name}
                {props.tooltip && (
                    <span
                        css={tw`lg:hidden flex justify-center items-center flex-none text-2xs rounded-full border border-2 border-solid border-grey-500 text-grey-500 h-4 w-4 ml-1 mt-1`}
                    >
                        i
                    </span>
                )}
                {props.tooltip && tooltip && (
                    <>
                        <TooltipArrow
                            css={tw`w-0 h-0`}
                            css={{
                                borderLeft: "5px solid transparent",
                                borderRight: "5px solid transparent",
                                borderBottom: "5px solid black",
                                position: "absolute",
                                top: "-5px",
                            }}
                        ></TooltipArrow>
                        <Tooltip
                            css={tw`absolute pointer-events-none top-0 text-xs p-2 bg-grey-800 text-white`}
                        >
                            {props.tooltip}
                        </Tooltip>
                    </>
                )}{" "}
            </h3>
            <div css={tw`flex flex-col sm:flex-row mt-1 md:mt-2`}>
                <div
                    css={tw`-mt-2 sm:mt-2 pr-2 line-through text-center text-lg text-grey-700`}
                    css={props.name === "Simple Start" ? tw`ml-6` : undefined}
                >
                    {fullPrice}€
                </div>
                <div css={tw`flex justify-center`}>
                    <div css={tw`font-bold text-2xl md:text-3xl flex`}>
                        {props.name === "Simple Start"
                            ? 5
                            : props.name === "Essentials"
                            ? 14
                            : 24}
                        {/* {discountPrice} */}
                        <span css={tw`font-semibold text-base pt-px`}>
                            {props.name !== "Simple Start" &&
                                remainder && ",50"}
                        </span>
                        €
                    </div>
                    <div
                        css={tw`text-xs md:text-sm flex flex-col justify-center ml-2 leading-none`}
                    >
                        HT
                        <br />
                        /mois
                    </div>
                </div>
            </div>
            <div css={tw`text-center text-xs md:text-sm text-grey-800`}>
                -50 % pendant 3 mois
            </div>
            <div css={tw`sm:px-5 mt-5 mb-4 text-center`}>
                <a
                    href={props.link}
                    css={tw`btn btn-green py-3 sm:py-6 px-4 sm:px-8`}
                    css={props.crown && tw`btn-dark`}
                    data-wa-link={`${props.datawa}${props.name.replace(
                        " ",
                        "-"
                    )}`}
                    data-sku={dataSKU}
                    data-action={"goto"}
                    data-object={"sign-up"}
                    data-ui-access-point={props.datawa}
                    data-ui-action={"clicked"}
                    data-ui-object={"button"}
                    data-ui-object-detail={`Démarrer - ${props.name.replace(
                        " ",
                        "-"
                    )}`}
                >
                    Démarrer
                </a>
            </div>{" "}
        </div>
    )
}

export default CompChartPrice
